import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileDefault = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M12.75 3.25v4a2 2 0 0 0 2 2h4m-12-6.5h5.172a2 2 0 0 1 1.414.586l5.328 5.328a2 2 0 0 1 .586 1.414v9.172a2 2 0 0 1-2 2H6.75a2 2 0 0 1-2-2V4.75a2 2 0 0 1 2-2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          d='M12 2H6.75A2.75 2.75 0 0 0 4 4.75v14.5A2.75 2.75 0 0 0 6.75 22h10.5A2.75 2.75 0 0 0 20 19.25V10h-5.25A2.75 2.75 0 0 1 12 7.25z'
          fill='currentColor'
        />
        <path
          d='m19.557 8.5-.07-.073-5.914-5.914-.073-.07V7.25c0 .69.56 1.25 1.25 1.25z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
